import { render, staticRenderFns } from "./QLD.vue?vue&type=template&id=2df447a7&scoped=true&"
import script from "./QLD.vue?vue&type=script&lang=js&"
export * from "./QLD.vue?vue&type=script&lang=js&"
import style0 from "./QLD.vue?vue&type=style&index=0&id=2df447a7&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df447a7",
  null
  
)

export default component.exports